import { getJSON, postJSON, deleteJSON, putJSON } from "@js/helpers/communication.js";
import { onSameModal } from "@js/helpers/state.js";

import update from "immutability-helper";

export const CE_OPEN_SAVE_CUSTOM_ROW_MODAL =
  "CE_OPEN_SAVE_CUSTOM_ROW_MODAL";

export const CE_DISMISS_SAVE_CUSTOM_ROW_MODAL =
  "CE_DISMISS_SAVE_CUSTOM_ROW_MODAL";

export const CE_SAVE_CUSTOM_ROW_STARTED = "CE_SAVE_CUSTOM_ROW_STARTED";
export const CE_SAVE_CUSTOM_ROW_SUCCESS = "CE_SAVE_CUSTOM_ROW_SUCCESS";
export const CE_SAVE_CUSTOM_ROW_FAILURE = "CE_SAVE_CUSTOM_ROW_FAILURE";
export const CE_SAVE_CUSTOM_ROW_ABORTED = "CE_SAVE_CUSTOM_ROW_ABORTED";

export const CE_MANAGE_CUSTOM_ROWS_LOAD_STARTED = "CE_MANAGE_CUSTOM_ROWS_LOAD_STARTED";
export const CE_MANAGE_CUSTOM_ROWS_LOAD_SUCCESS = "CE_MANAGE_CUSTOM_ROWS_LOAD_SUCCESS";
export const CE_MANAGE_CUSTOM_ROWS_LOAD_FAILURE = "CE_MANAGE_CUSTOM_ROWS_LOAD_FAILURE";
export const CE_MANAGE_CUSTOM_ROWS_LOAD_ABORTED = "CE_MANAGE_CUSTOM_ROWS_LOAD_ABORTED";

export const CE_DELETE_CUSTOM_ROW_REQUEST = "CE_DELETE_CUSTOM_ROW_REQUEST";
export const CE_DELETE_CUSTOM_ROW_STARTED = "CE_DELETE_CUSTOM_ROW_STARTED";
export const CE_DELETE_CUSTOM_ROW_SUCCESS = "CE_DELETE_CUSTOM_ROW_SUCCESS";
export const CE_DELETE_CUSTOM_ROW_FAILURE = "CE_DELETE_CUSTOM_ROW_FAILURE";
export const CE_DELETE_CUSTOM_ROW_ABORTED = "CE_DELETE_CUSTOM_ROW_ABORTED";

export const CE_RENAME_CUSTOM_ROW_REQUEST = "CE_RENAME_CUSTOM_ROW_REQUEST";
export const CE_RENAME_CUSTOM_ROW_STARTED = "CE_RENAME_CUSTOM_ROW_STARTED";
export const CE_RENAME_CUSTOM_ROW_SUCCESS = "CE_RENAME_CUSTOM_ROW_SUCCESS";
export const CE_RENAME_CUSTOM_ROW_FAILURE = "CE_RENAME_CUSTOM_ROW_FAILURE";
export const CE_RENAME_CUSTOM_ROW_ABORTED = "CE_RENAME_CUSTOM_ROW_ABORTED";

export const ceOpenSaveCustomRowModal = (beeRowArgs) => ({
  type: CE_OPEN_SAVE_CUSTOM_ROW_MODAL,
  bee_row_args: beeRowArgs,
});

export const ceSubmitSaveCustomRowModal = (connector) => (dispatch, getState) => {
  dispatch({ type: CE_SAVE_CUSTOM_ROW_STARTED });

  let state = getState();
  let modalState = state.modal.state;

  let name = modalState.name.trim();
  let beeRowArgs = update(modalState.bee_row_args, { metadata: { $set: { name: name } } });
  let mailingListId = state.mailing_list_id;

  let postData = {
    overwrite: modalState.offer_overwrite,
    bee_custom_row: {
      name: name,
      bee_json: JSON.stringify(beeRowArgs),
    },
  };

  let createCustomRowUrl =
    Routes.api_v2_mailing_list_bee_custom_rows_path({
      mailing_list_id: mailingListId,
    });

  postJSON(createCustomRowUrl, postData, onSameModal(getState, (data, err) => {
    if ( err || !data.success || data.error_message ) {
      dispatch({
        type: CE_SAVE_CUSTOM_ROW_FAILURE,
        error_message: err || data.error_message,
        offer_overwrite: data && data.error_due_to_uniqueness,
      });
      return;
    }

    dispatch({
      type: CE_SAVE_CUSTOM_ROW_SUCCESS,
      data: data,
    });

    const metadataWithNewId = update(beeRowArgs.metadata, {
      $merge: {
        id: data.data.bee_custom_row.id,
      },
    });

    connector.trigger({
      type: "save-custom-row-success",
      metadata: metadataWithNewId,
    });
  }));
};

export const ceDismissSaveCustomRowModal = (connector) => (dispatch, getState) => {
  dispatch({ type: CE_DISMISS_SAVE_CUSTOM_ROW_MODAL });
  connector.trigger({ type: "save-custom-row-aborted" });
};

export const ceModalManageCustomRowsOpen = () => (dispatch, getState) => {
  const initialState = getState();
  const mailingListId = initialState.mailing_list_id;
  const url = Routes.api_v2_mailing_list_bee_custom_rows_path(mailingListId, { stub: true });

  dispatch({ type: CE_MANAGE_CUSTOM_ROWS_LOAD_STARTED });

  getJSON(url, onSameModal(getState, (data, err) => {
    if ( err || !data.success || data.error_message ) {
      dispatch({
        type: CE_MANAGE_CUSTOM_ROWS_LOAD_FAILURE,
        error_message: err || data.error_message,
      });
      return;
    }

    dispatch({
      type: CE_MANAGE_CUSTOM_ROWS_LOAD_SUCCESS,
      custom_rows: data.data.bee_custom_rows,
    });
  }));
};

export const ceModalManageCustomRowsDismiss = () => ({
  type: CE_MANAGE_CUSTOM_ROWS_LOAD_ABORTED,
});

export const ceDeleteCustomRow = (rowId) => {
  return {
    type: CE_DELETE_CUSTOM_ROW_REQUEST,
    row_id: rowId,
  };
};

export const ceDeleteCustomRowCancel = (rowId) => {
  return {
    type: CE_DELETE_CUSTOM_ROW_ABORTED,
  };
};

export const ceDeleteCustomRowConfirm = (rowId) => (dispatch, getState) => {
  const initialState = getState();
  const mailingListId = initialState.mailing_list_id;
  const url = Routes.api_v2_mailing_list_bee_custom_row_path(mailingListId, rowId);

  dispatch({
    type: CE_DELETE_CUSTOM_ROW_STARTED,
    row_id: rowId,
  });

  deleteJSON(url, onSameModal(getState, (data, err) => {
    const finalState = getState();
    if ( finalState.modal.state.delete_row_id != rowId ) return;

    if ( err || !data.success || data.error_message ) {
      dispatch({
        type: CE_DELETE_CUSTOM_ROW_FAILURE,
        row_id: rowId,
        response: data,
        error_message: err || data.error_message,
      });
      return;
    }

    dispatch({
      type: CE_DELETE_CUSTOM_ROW_SUCCESS,
      row_id: rowId,
    });
  }));
};

export const ceRenameCustomRow = (rowId, rowName) => {
  return {
    type: CE_RENAME_CUSTOM_ROW_REQUEST,
    row_id: rowId,
    row_name: rowName,
  };
};

export const ceRenameCustomRowSave = (rowId, rowName) => (dispatch, getState) => {
  const initialState = getState();
  const mailingListId = initialState.mailing_list_id;
  const url = Routes.api_v2_mailing_list_bee_custom_row_path(mailingListId, rowId);

  dispatch({
    type: CE_RENAME_CUSTOM_ROW_STARTED,
    row_id: rowId,
    row_name: rowName,
  });

  const postData = {
    bee_custom_row: {
      name: rowName,
    },
  };

  putJSON(url, postData, onSameModal(getState, (data, err) => {
    const finalState = getState();
    if ( finalState.modal.state.rename_row_id != rowId ) return;

    if ( err || !data.success || data.error_message ) {
      dispatch({
        type: CE_RENAME_CUSTOM_ROW_FAILURE,
        row_id: rowId,
        error_message: err || data.error_message,
      });
      return;
    }

    dispatch({
      type: CE_RENAME_CUSTOM_ROW_SUCCESS,
      row_id: rowId,
      row_name: rowName,
    });
  }));
};

export const ceRenameCustomRowCancel = () => {
  return {
    type: CE_RENAME_CUSTOM_ROW_ABORTED,
  };
};

export const ceSaveCustomRowHtml = (rowJson, rowHtml) => (dispatch, getState) => {
  const initialState = getState();
  const mailingListId = initialState.mailing_list_id;
  const rowId = JSON.parse(rowJson).metadata.id;
  const url = Routes.api_v2_mailing_list_bee_custom_row_path(mailingListId, rowId);

  const postData = {
    bee_custom_row: {
      bee_html: rowHtml,
    },
  };

  putJSON(url, postData, onSameModal(getState, (data, err) => {
    // In practice this should never really fail, so we punt with an ugly
    // browser error message if we encounter an issue. A failure in saving
    // the row's HTML does not affect its ability to be used.
    const error = err || data.error_message;
    if ( error ) {
      alert(t("phrases.error_saving_custom_row_html") + ": " + error);
    }
  }));
};
